<div class="relative min-h-screen w-[375px] mx-auto">
  <img src="./../../../../../assets/images/not-found-page.svg" />
  <div class="text-center text-2xl font-semibold">Xin lỗi nhé!</div>
  <div class="font-medium text-center mt-2">
    Chúng tôi không thể tìm thấy trang đó, đừng lo lắng, mọi thứ vẫn tuyệt vời
    phải không?!
  </div>
</div>
